module.exports = __webpack_public_path__ + "media/images/vp/icon.submenu.edu.black-3cbceeec6595245e201a598b8ad07563.svg";